import { render, staticRenderFns } from "./workStatPage.vue?vue&type=template&id=065d0c11&scoped=true&"
import script from "./workStatPage.vue?vue&type=script&lang=js&"
export * from "./workStatPage.vue?vue&type=script&lang=js&"
import style0 from "./workStatPage.vue?vue&type=style&index=0&id=065d0c11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d0c11",
  null
  
)

export default component.exports